import { useContext, useEffect, useMemo, useRef, useState } from "react";
import RequiredDocumentsModalRaw from "./RequiredDocumentsModal";
import MissingDocumentRaw from "./missingDocument";
import AuthenticateYourIdRaw from "./authenticateYourId";
import DocumentScanningRaw from "./documentScanning";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstance from "../../services/authWrapper";
import BasicInfoModalRaw from "./BasicInfoModal";
import constants from "../../Utils/constants";
import Loader from "../../components/Loader";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useLocation, useNavigate } from "react-router-dom";
import TenantContext from "../../context/tenant/TenantContext";
import LandLordContext from "../../context/landlord/LandLordContext";
import useTranslator from "../../hooks/useTranslator";
import i18next from "i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { sendUniversalMail } from "../../services/sharedService";
import {
  isClientIdentificationActive,
  haveValue,
  toast,
} from "../../helper/common";
import { useCookies } from "react-cookie";
import BankModalRaw from "./BankModal";
import GuarantorModalRaw from "./GuarantorModal";
import FlatmateOrGuarantorAddFormRaw from "../../components/TenantDetails/FlatmateOrGuarantorAddForm";
import FreeTextModalRaw from "../../components/Tenant/FreeTextModal";
import CreateApplicationStep from "./CreateApplicationStep";
import PostApplicationModals from "./PostApplicationModals";
import GuarantorDecisionScreen from "../../components/GuarantorDecisionScreen/GuarantorDecisionScreen";
import GuarantorBackingScreen from "../../components/GuarantorBackingScreen/GuarantorBackingScreen";
import { getSharedLandlordNames } from "../../components/Onboarding/signupEntrySource";
import OnboardingProgressRaw from "./OnboardingProgress";
import GuarantorOnboardingProgress from "./GuarantorOnboardingProgress";
import CoTenantOnboardingProgress from "./CoTenantOnboardingProgress";
import RenewGuarantorsStep from "./RenewGuarantorsStep";
import CompanyProfileCompletedModal from "./CompanyProfileCompletedModal";
import RenewExitConfirm from "./RenewExitConfirm";
import OnfidoModal from "../../components/OnfidoModal/OnfidoModal";
import TinkModal from "../../components/TinkModal/TinkModal";
import useDocumentAnalysis from "../../hooks/useDocumentAnalysis";
import ClientIdentificationForm from "../../components/ClientIdentificationForm/ClientIdentificationForm";
import RequestAcceptingModalRaw from "../../components/Tenant/Guarantor/RequestAcceptingModal";
import TenantRequirementsFlow from "../../components/TenantRequirements/TenantRequirementsFlow";

const RequiredDocumentsModal: any = RequiredDocumentsModalRaw;
const MissingDocument: any = MissingDocumentRaw;
const AuthenticateYourId: any = AuthenticateYourIdRaw;
const DocumentScanning: any = DocumentScanningRaw;
const BasicInfoModal: any = BasicInfoModalRaw;
const BankModal: any = BankModalRaw;
const GuarantorModal: any = GuarantorModalRaw;
const FlatmateOrGuarantorAddForm: any = FlatmateOrGuarantorAddFormRaw;
const FreeTextModal: any = FreeTextModalRaw;
const RequestAcceptingModal: any = RequestAcceptingModalRaw;
const OnboardingProgress: any = OnboardingProgressRaw;

const OnboardingStep = {
  BasicInfo: 1,
  AuthenticateId: 2,
  RequiredDocuments: 3,
  MissingDocument: 4,
  DocumentScanning: 5,
  Bank: 6,
  Guarantor: 7,
  FreeText: 8,
  Skor: 9,
  CompanyCompleted: 10,
} as const;

type OnboardingFlow = "tenant" | "guarantor" | "co_tenant" | "edit";

function OnboardingMain({ isDummySignup }) {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { user: originalUser, loadUser, getPendingGuaantees } = authContext;
  const {
    createBasicGuarantorAccount,
    updateBasicGuarantorAccount,
    guarantorAddedDetails,
    deleteSelectedOnboardingUser,
    createBasicCoTenantAccount,
    updateBasicCoTenantAccount,
    coTenantAddedDetails,
    deleteSelectedCoTenant,
    getBackedTenantShared,
    shareProfile,
    getUserModuleData,
    checkDocumentAnalysisStatus,
  } = useContext(TenantContext);
  const location = useLocation();
  const [step, setStep] = useState<number>(OnboardingStep.BasicInfo);
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [pageLoading, setPageLoading] = useState(false);
  const [selectedOnboardingUsers, setSelectedOnboardingUsers] = useState<any[]>(
    []
  );
  const [user, setUser] = useState<any>({});
  // Single shared analysis cache for Required (step 3) + Missing (step 4).
  // Fetched once per tenant, reused on back/forward, invalidated on new upload.
  const {
    analysis: documentAnalysisResponse,
    status: documentAnalysisStatus,
    loading: documentAnalysisLoading,
    refresh: refreshDocumentAnalysis,
  } = useDocumentAnalysis(
    (user as any)?._id,
    checkDocumentAnalysisStatus,
    step === OnboardingStep.RequiredDocuments ||
    step === OnboardingStep.MissingDocument
  );
  const [workspaceSkipSteps, setWorkspaceSkipSteps] = useState<string[]>([]);
  const [
    clientIdentificationInvitationWorkspace,
    setClientIdentificationInvitationWorkspace,
  ] = useState<any>(null);
  const [
    showCompanyClientIdentificationForm,
    setShowCompanyClientIdentificationForm,
  ] = useState(false);
  const [showGuarantorModel, setShowGuarantorModel] = useState(false);
  const [guarantorAccountPresent, setGuarantorAccountPresent] = useState(false);
  const isGuarantor = location.pathname === "/guarantor/onboarding";
  const isCoTenant = location.pathname === "/co-tenant/onboarding";
  const queryParameters = new URLSearchParams(window.location.search);
  const guarantor_a_id = queryParameters.get("guarantor_a_id");
  const co_tenant_a_id = queryParameters.get("co_tenant_a_id");
  const isFirstTime = queryParameters.get("welcome");
  const guarantorName = queryParameters.get("guarantorName");
  const coTenantName =
    queryParameters.get("coTenantName") || queryParameters.get("co_tenantName");
  const showSidebar = queryParameters.get("showSidebar") === "true";
  const isIframe = localStorage.getItem("app_type") === "skor-sdk";
  const allowGuarantorEdit =
    isGuarantor && queryParameters.get("action") === "edit";
  const allowCoTenantEdit =
    isCoTenant && queryParameters.get("action") === "edit";
  const useCompactGuarantorForm =
    allowGuarantorEdit && queryParameters.get("form") === "compact";
  const isEditMode = location.pathname === "/user/edit";
  const paramStep = queryParameters.get("step");
  const edit_step = parseInt(paramStep ?? "", 10);
  const flow: OnboardingFlow = isGuarantor
    ? "guarantor"
    : isCoTenant
      ? "co_tenant"
      : isEditMode
        ? "edit"
        : "tenant";
  const isCompanySelected = formData?.employment_status === constants.company;

  // Optimistic company skip: reflect in sidebar/navigation immediately, even
  // before the backend persists skip_steps. KYC remains part of the company flow.
  const COMPANY_SKIP_STEPS = useMemo(
    () => [
      constants.SKIP_STEPS_ENUM.bank_onboarding,
      constants.SKIP_STEPS_ENUM.guarantor_onboarding,
      constants.SKIP_STEPS_ENUM.context_onboarding,
      constants.SKIP_STEPS_ENUM.consent_onboarding,
    ],
    []
  );

  const effectiveSkipSteps: string[] = useMemo(
    () =>
      Array.from(
        new Set([
          ...(flow === "tenant" ? workspaceSkipSteps : []),
          ...(user?.skip_steps ?? []).filter(
            (skipStep: string) =>
              !(
                flow === "tenant" &&
                isCompanySelected &&
                skipStep === constants.SKIP_STEPS_ENUM.kyc_onboarding
              )
          ),
          ...(flow === "tenant" &&
            isCompanySelected &&
            !isGuarantor &&
            !isCoTenant &&
            !isEditMode
            ? COMPANY_SKIP_STEPS
            : []),
        ])
      ),
    [
      flow,
      workspaceSkipSteps,
      user?.skip_steps,
      isCompanySelected,
      isGuarantor,
      isCoTenant,
      isEditMode,
      COMPANY_SKIP_STEPS,
    ]
  );
  const [runDetectKycDocs, setRunDetectKycDocs] = useState(true);
  const [identityStage, setIdentityStage] = useState("document");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedProtectedHousingDocs, setSelectedProtectedHousingDocs] =
    useState<any[]>([]);
  const [addedFiles, setAddedFiles] = useState<any[]>([]);
  const [modules, setModules] = useState(null);
  const [pendingGuaranteesRequests, setPendingGuaranteesRequests] = useState<
    any[]
  >([]);
  const [pendingRequestsGuranteesLoading, setPendingRequestsGuranteesLoading] =
    useState(false);
  const [lessGuarantorInfoModal, setlessGuarantorInfoModal] = useState(false);
  const isPendingDataLoaded = useRef({ guarantees: false });
  const isCompletingSkippedRenewal = useRef(false);
  const isCompletingIframeProfile = useRef(false);
  const iframeCompletionEventTimer = useRef<ReturnType<
    typeof setTimeout
  > | null>(null);
  const [iframeProfileCompleted, setIframeProfileCompleted] = useState(false);
  const [hasVisitedMissing, setHasVisitedMissing] = useState(false);
  const [missingSkipAnalysis, setMissingSkipAnalysis] = useState(false);
  const [deletedReviewFileIds, setDeletedReviewFileIds] = useState<string[]>(
    []
  );
  const [prevStep, setPrevStep] = useState<number | null>(null);
  const [showExitModal, setShowExitModal] = useState(false);

  const handleCompleteOnboarding = async () => {
    try {
      const payload: Record<string, any> = {
        is_edit: false,
        profile_completed: true,
        role: localStorage.getItem("usertype"),
        step: 9,
      };
      await upsertUserProfile(payload);
    } catch (err) {
      console.error("Error completing onboarding:", err);
    }
  };

  const handleExitOnboarding = async () => {
    try {
      const payload: Record<string, any> = {
        is_edit: false,
        profile_completed: true,
        role: localStorage.getItem("usertype"),
        step: 9,
        is_exit: true,
      };
      await upsertUserProfile(payload);
    } catch (err) {
      console.error("Error exiting onboarding:", err);
    }
  };

  const isKycDone = user?.onfido_user_kyc?.server_status === "completed";

  const {
    isExpired: isKycExpired,
    isKycAutoSkippable,
    isKycSkippable,
  } = useMemo(() => {
    const expiry =
      user?.onfido_user_kyc?.onfido_workflow_res?.resource?.output
        ?.document_report?.properties?.date_of_expiry ??
      user?.onfido_user_kyc?.onfido_workflow_res?.output?.document_report
        ?.properties?.date_of_expiry;
    const isExpired = (() => {
      if (!expiry) return false;
      const expiryDate = new Date(expiry);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return expiryDate <= today;
    })();
    const done = user?.onfido_user_kyc?.server_status === "completed";
    // auto-skip only for renewal with non-expired document
    const autoSkippable = !!(user?.re_new_pending && expiry && !isExpired);
    // skip button visible when KYC done (and not expired) OR renewal auto-skippable
    const skippable = (!!done && !isExpired) || autoSkippable;
    return {
      isExpired: isExpired,
      isKycAutoSkippable: autoSkippable,
      isKycSkippable: skippable,
    };
  }, [user?.onfido_user_kyc, user?.re_new_pending]);

  const isStepSkippedByConfig = (s: number) => {
    const skip: string[] = effectiveSkipSteps ?? [];
    if (
      flow === "tenant" &&
      s === OnboardingStep.BasicInfo &&
      skip.includes(constants.SKIP_STEPS_ENUM.basic_info)
    )
      return true;
    if (s === OnboardingStep.AuthenticateId) {
      if (isKycAutoSkippable) return true;
      if (
        flow === "tenant" &&
        skip.includes(constants.SKIP_STEPS_ENUM.kyc_onboarding)
      )
        return true;
    }
    if (
      flow === "tenant" &&
      s === OnboardingStep.RequiredDocuments &&
      skip.includes(constants.SKIP_STEPS_ENUM.required_documents)
    )
      return true;
    if (
      flow === "tenant" &&
      s === OnboardingStep.MissingDocument &&
      skip.includes(constants.SKIP_STEPS_ENUM.missing_document)
    )
      return true;
    if (
      s === OnboardingStep.Bank &&
      skip.includes(constants.SKIP_STEPS_ENUM.bank_onboarding)
    )
      return true;
    if (
      s === OnboardingStep.Guarantor &&
      skip.includes(constants.SKIP_STEPS_ENUM.guarantor_onboarding)
    )
      return true;
    return false;
  };

  const isRenew = !!user?.re_new_pending;
  const showRenewExit =
    isRenew && flow === "tenant" && !isGuarantor && !isCoTenant && !isEditMode;

  const isStepAllowedForFlow = (s: number) => {
    // company: BasicInfo -> KYC -> Required/Missing -> Profile completed
    if (
      isCompanySelected &&
      !isGuarantor &&
      !isCoTenant &&
      !isEditMode &&
      (s === OnboardingStep.DocumentScanning ||
        s === OnboardingStep.Bank ||
        s === OnboardingStep.FreeText)
    )
      return false;
    if (s === OnboardingStep.CompanyCompleted)
      return isCompanySelected && !isGuarantor && !isCoTenant && !isEditMode;
    // renew: finish on guarantors, not application
    if (isRenew && s === OnboardingStep.Skor) return false;
    if (isRenew && s === OnboardingStep.FreeText) return false;
    if (isRenew && s === OnboardingStep.Guarantor) return true;
    // tenant/co-tenant create flow: hide Guarantor, show CreateApplication (Skor) only for tenant
    if (
      (flow === "tenant" || flow === "co_tenant") &&
      s === OnboardingStep.Guarantor
    )
      return false;
    // tenant: FreeText is legacy CreateApplication alias – keep only Skor to avoid duplicate screen
    if (flow === "tenant" && s === OnboardingStep.FreeText) return false;
    // edit / guarantor / co_tenant flows: hide CreateApplication steps
    if (
      (flow === "edit" || flow === "guarantor" || flow === "co_tenant") &&
      (s === OnboardingStep.FreeText || s === OnboardingStep.Skor)
    )
      return false;
    return true;
  };

  const getNextValidStep = (from: number, direction: 1 | -1) => {
    let s = from + direction;
    // clamp
    if (s < OnboardingStep.BasicInfo) return OnboardingStep.BasicInfo;
    if (s > OnboardingStep.Skor) return OnboardingStep.Skor;
    while (
      s >= OnboardingStep.BasicInfo &&
      s <= OnboardingStep.Skor &&
      (!isStepAllowedForFlow(s) || isStepSkippedByConfig(s))
    ) {
      if (
        direction === 1 &&
        isRenew &&
        s === OnboardingStep.Guarantor &&
        isStepSkippedByConfig(s)
      ) {
        return s;
      }
      s += direction;
      if (s < OnboardingStep.BasicInfo) return OnboardingStep.BasicInfo;
      if (s > OnboardingStep.Skor) {
        if (flow === "edit" || flow === "guarantor" || flow === "co_tenant")
          return from;
        // company ends at MissingDocument (4) / DocumentScanning (5) - don't bounce to Skor
        if (isCompanySelected && !isGuarantor && !isCoTenant && !isEditMode)
          return from;
        return OnboardingStep.Skor;
      }
    }
    return s;
  };

  useEffect(() => {
    if (step === OnboardingStep.MissingDocument) setHasVisitedMissing(true);
    // track previous step for back-button logic
    return () => setPrevStep(step);
  }, [step]);

  // keep prevStep up to date on step change
  useEffect(() => {
    // no-op - prevStep is set via cleanup above; also handle goTo/next/prev which set synchronously
  }, []);

  // Auto-skip any step flagged in skip_steps (incl. KYC expiry)
  useEffect(() => {
    if (isStepSkippedByConfig(step)) {
      if (isRenew && step === OnboardingStep.Guarantor) {
        if (isCompletingSkippedRenewal.current) return;
        isCompletingSkippedRenewal.current = true;
        void handleCompleteOnboarding().then(() =>
          navigate("/home?welcome=true")
        );
        return;
      }
      const newStep = getNextValidStep(step, 1);
      if (newStep === step) return;
      if (isEditMode) {
        const params = new URLSearchParams(window.location.search);
        params.set("step", String(newStep));
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${params.toString()}`
        );
      }
      setStep(newStep);
      return;
    }

    // Recover persisted legacy steps that are not valid for the active flow.
    // Tenant creation moves forward to Create Application; renew/edit/guarantor
    // flows move back to their last valid step.
    if (!isCompanySelected && !isStepAllowedForFlow(step)) {
      if (
        (flow === "edit" || flow === "guarantor" || flow === "co_tenant") &&
        step === OnboardingStep.Skor
      ) {
        return;
      }
      const direction: 1 | -1 = flow === "tenant" && !isRenew ? 1 : -1;
      const newStep = getNextValidStep(step, direction);
      if (newStep !== step) setStep(newStep);
    }
  }, [
    step,
    isKycAutoSkippable,
    effectiveSkipSteps,
    isRenew,
    navigate,
    flow,
    isCompanySelected,
  ]);

  const handleSkipKyc = () => {
    // Renew: skipping identity verification should resume at document collection,
    // not jump to Bank/Guarantor/Skor.
    const newStep = getNextValidStep(OnboardingStep.AuthenticateId, 1);
    if (isEditMode) {
      const params = new URLSearchParams(window.location.search);
      params.set("step", String(newStep));
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    }
    setStep(newStep);
  };

  const [cookies, setCookie, removeCookie] = useCookies<string>([
    "sharedProfileLink",
    "tenantSignupFlow",
    "requestProfileLink",
  ]);

  const getModuledata = async () => {
    let modules = null;
    const public_key = localStorage.getItem("publicKey");

    if (
      haveValue(public_key) &&
      localStorage.getItem("app_type") === "skor-sdk"
    ) {
      modules = await getUserModuleData(public_key);
    }

    const rawModules = modules?.data?.modules || null;

    let normalizedModules = null;
    if (rawModules === "*") {
      normalizedModules = ["*"];
    } else if (typeof rawModules === "string") {
      normalizedModules = rawModules
        .split(",")
        .map((m) => m.trim())
        .filter(Boolean);
    }

    setModules(normalizedModules);
  };
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [acceptedGuaranteeName, setAcceptedGuaranteeName] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [onfidoModal, setOnfidoModal] = useState(false);
  const [tinkModal, setTinkModal] = useState(false);
  const [isBankAdded, setIsBankAdded] = useState(false);
  // (acceptedGuaranteeName is the D screen's accept sink; G copy reads the
  // persisted backing result.)
  // G result payload for cases 12-13 (persisted across reloads, cleared on
  // dashboard exit). landlordName is null for case 12 (nothing shared yet).
  const [backingResult, setBackingResult] = useState<{
    fullName: string;
    firstName: string;
    landlordName: string | null;
  } | null>(() => {
    try {
      const raw = sessionStorage.getItem("signupGuarantorBacking");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [completingBacking, setCompletingBacking] = useState(false);
  const [createdApp, setCreatedApp] = useState<{
    title: string;
    peopleCount: number;
    appId?: string;
    members?: {
      name: string;
      email?: string;
      role: "tenant" | "guarantor";
    }[];
    pendingGuarantors?: {
      name: string;
      email?: string;
      relation?: string;
    }[];
    pendingCoTenants?: { name: string; email?: string }[];
  } | null>(null);
  const [pendingStage, setPendingStage] = useState<
    "pending" | "selfManaged" | "selfManagedCoTenant" | null
  >(null);

  const [currentLang, setCurrentLang] = useState(
    () => localStorage.getItem("i18nextLng")?.toLowerCase() || "es"
  );
  const [isLangChanging, setIsLangChanging] = useState(false);
  const isChangingLang = useRef(false);

  useEffect(() => {
    if (haveValue(user?.lang) && user?.lang !== currentLang) {
      const e: any = { target: { value: user?.lang } };
      handleLanguageChange(e as any);
    }
    // eslint-disable-next-line
  }, [user?.lang]);

  const handleLanguageChange = async (
    eOrLang: React.MouseEvent | string | { target: { value: string } }
  ) => {
    let langVal: string;
    if (typeof eOrLang === "string") langVal = eOrLang;
    else if ((eOrLang as any)?.target?.value)
      langVal = (eOrLang as any).target.value;
    else langVal = currentLang === "es" ? "en-us" : "es";

    if (isChangingLang.current) return;
    isChangingLang.current = true;
    setIsLangChanging(true);
    try {
      await i18next.changeLanguage(langVal);
      try {
        await authContext.changeUserLng?.({ skipUserLoad: true });
      } catch { }
      setCurrentLang(langVal.toLowerCase());
    } finally {
      setTimeout(() => {
        isChangingLang.current = false;
        setIsLangChanging(false);
      }, 1500);
    }
  };

  useEffect(() => {
    if (step === OnboardingStep.Skor && flow !== "tenant") {
      navigate("/home?welcome=true");
    }
  }, [flow, navigate, step]);

  useEffect(() => {
    const user_type = localStorage.getItem("usertype");
    const userId = localStorage.getItem("saveduserid");
    if (haveValue(cookies.requestProfileLink) && user_type === "tenant") {
      if (haveValue(userId)) {
        const havePropertyId = haveValue(cookies.property_id);
        const invitationToken = haveValue(cookies.invitationToken);
        const payload: Record<string, any> = {
          shareType: "lLink",
          pendingDecision: true,
        };
        if (havePropertyId) {
          payload.property_id = cookies.property_id;
        }
        setCookie("tenantSignupFlow", "true", { path: "/", maxAge: 7200 });
        shareProfile(
          userId,
          cookies.requestProfileLink,
          "null",
          "full",
          payload
        );
      }
    }
  }, []);

  const applyProfileData = (_user: any) => {
    setFormData({
      fname: _user?.fname || "",
      lname: _user?.lname || "",
      document_type:
        _user?.passport_id && !_user?.dni_nie ? "passport" : "dni_nie",
      identity_number: _user?.dni_nie || _user?.passport_id || "",
      post_code: _user?.post_code || "",
      dob: _user?.dob ? _user.dob.split("T")[0] : "",
      employment_status: _user?.employment_status || "",
      employment_category: _user?.employment_category || "",
      current_annual_income: _user?.current_annual_income ?? "",
      protected_housing: _user?.protected_housing || false,
      email: _user?.email || "",
      gurantor_relation: _user?.gurantor_relation || "",
      phone_number: _user?.phone_number || "",
      currency: _user?.currency || "EUR",
      company_legal_name: _user?.company_legal_name || "",
      company_cif: _user?.company_cif || "",
      company_type: _user?.company_type || "",
      company_cnae: _user?.company_cnae || "",
      company_representative_position:
        _user?.company_representative_position || "",
      highest_qualification: _user?.highest_qualification || "",
    });
    setPhoneNumber(_user?.phone_number || "");
    setSelectedProtectedHousingDocs(
      !_user?.protected_housing
        ? ["no"]
        : _user?.tenant_extra_field_id?.public_housing_docs
    );
    const isApplicationProfileEdit =
      sessionStorage.getItem("applicationProfileEditMode") === "true" ||
      new URLSearchParams(window.location.search).get("editProfile") === "true";
    if (isApplicationProfileEdit) {
      setStep(OnboardingStep.BasicInfo);
      // Only clear edit flag once real user data is present - avoids clearing on initial null call
      // and keeps guard active until the completed profile is forced to step 1. Final Skor
      // completion will then correctly restore to /application-profiles.
      if (_user && (_user._id || _user.email || _user.step)) {
        sessionStorage.removeItem("applicationProfileEditMode");
        const url = new URL(window.location.href);
        if (url.searchParams.get("editProfile")) {
          url.searchParams.delete("editProfile");
          window.history.replaceState({}, "", url.toString());
        }
      }
    } else if (allowGuarantorEdit) {
      setStep(1);
    } else if (!isEditMode) {
      setStep(_user?.step ?? OnboardingStep.BasicInfo);
    } else {
      setStep([1, 2, 3].includes(Number(edit_step)) ? Number(edit_step) : 1);
    }
  };

  const loadData = async () => {
    if (isDummySignup) return;
    try {
      setPageLoading(true);
      await loadUser("tenant");
    } finally {
      setPageLoading(false);
    }
  };

  const loadGuarantorData = async (
    loadFor: string,
    gur_id?: string,
    needLoading?: boolean
  ) => {
    try {
      if (needLoading) {
        setPageLoading(true);
      }
      const res = await guarantorAddedDetails(gur_id ?? guarantor_a_id);
      if (loadFor === "applyProfile") {
        setUser({
          ...res?.success_res?.guarantor_id,
          gurantor_relation: res?.success_res?.gurantor_relation,
        });
        applyProfileData({
          ...res?.success_res?.guarantor_id,
          gurantor_relation: res?.success_res?.gurantor_relation,
        });
      }
      return res;
    } catch (err) {
      console.log("Error updating guarantor", err);
    } finally {
      setPageLoading(false);
    }
  };

  const loadCoTenantData = async (
    loadFor: string,
    co_id?: string,
    needLoading?: boolean
  ) => {
    try {
      if (needLoading) {
        setPageLoading(true);
      }
      const res = await coTenantAddedDetails(co_id ?? co_tenant_a_id);
      if (loadFor === "applyProfile") {
        const tenantData = res?.success_res?.tenant || res?.success_res;
        setUser(tenantData);
        applyProfileData(tenantData || {});
      }
      return res;
    } catch (err) {
      console.log("Error updating co-tenant", err);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (isGuarantor) {
      const qp = new URLSearchParams(window.location.search);
      const prefillEmail = qp.get("email") || "";
      const prefillFullName = qp.get("guarantorName")?.trim() || "";
      const [nameFirst = "", ...nameLastParts] = prefillFullName.split(/\s+/);
      const prefillFirstName =
        qp.get("firstName") || qp.get("first_name") || nameFirst;
      const prefillLastName =
        qp.get("lastName") || qp.get("last_name") || nameLastParts.join(" ");
      const prefillRelation =
        qp.get("gurantor_relation") || qp.get("guarantor_relation") || "";
      const hasPrefill = !!(
        prefillEmail ||
        prefillFirstName ||
        prefillLastName ||
        prefillRelation
      );
      if (step === OnboardingStep.BasicInfo && !guarantor_a_id && !hasPrefill) {
        setShowGuarantorModel(true);
      }
      if (guarantor_a_id) {
        loadGuarantorData("applyProfile");
        if (useCompactGuarantorForm) {
          setlessGuarantorInfoModal(true);
        }
      } else {
        applyProfileData({
          fname: prefillFirstName,
          lname: prefillLastName,
          email: prefillEmail,
          gurantor_relation: prefillRelation,
        });
      }
      loadData();
    } else if (isCoTenant) {
      const qp = new URLSearchParams(window.location.search);
      const prefillEmail = qp.get("email") || "";
      const prefillFirstName =
        qp.get("firstName") || qp.get("first_name") || "";
      const hasPrefill = !!(prefillEmail || prefillFirstName);
      if (co_tenant_a_id) {
        loadCoTenantData("applyProfile");
      } else {
        applyProfileData({
          fname: prefillFirstName,
          email: prefillEmail,
        });
      }
      loadData();
    } else {
      loadData();
    }
  }, [location.pathname, guarantor_a_id, useCompactGuarantorForm]);

  useEffect(() => {
    if (!isGuarantor && !isCoTenant) {
      setUser(originalUser);
      applyProfileData(originalUser);
      if (!isPendingDataLoaded.current.guarantees) {
        loadPendingGuarantees();
        isPendingDataLoaded.current.guarantees = true;
      }
    }
  }, [originalUser, location.pathname]);

  const upsertUserProfile = async (data: any) => {
    try {
      let res;
      if (isGuarantor) {
        if (guarantor_a_id) {
          const updatedPayload = {
            ...data,
            guarantor_id: guarantor_a_id,
          };
          res = await updateBasicGuarantorAccount(updatedPayload);
          await loadGuarantorData("applyProfile");
        } else {
          res = await createBasicGuarantorAccount(data);
          if (res.created_guarantor_id) {
            if (haveValue(guarantorName)) {
              const payload = {
                tenant_id: originalUser?._id,
                type: "guarantor",
                name: guarantorName,
                guarantor_id: res.guarantor_id ?? null,
              };
              await deleteSelectedOnboardingUser(payload);
            }
            const url = new URL(window.location.href);
            url.searchParams.set("guarantor_a_id", res.created_guarantor_id);
            window.history.pushState({}, "", url.toString());
          }
          await loadGuarantorData("applyProfile", res.created_guarantor_id);
        }
      } else if (isCoTenant) {
        if (co_tenant_a_id) {
          const updatedPayload = {
            ...data,
            co_tenant_id: co_tenant_a_id,
            coTenantId: co_tenant_a_id,
          };
          res = await updateBasicCoTenantAccount(updatedPayload);
          await loadCoTenantData("applyProfile");
        } else {
          res = await createBasicCoTenantAccount(data);
          if (res.created_co_tenant_id || res.co_tenant_id) {
            const newId = res.created_co_tenant_id || res.co_tenant_id;
            if (haveValue(coTenantName)) {
              const payload = {
                tenant_id: originalUser?._id,
                name: coTenantName,
                type: "co_tenant",
                co_tenant_id: newId,
              };
              await deleteSelectedCoTenant(payload);
            }
            const url = new URL(window.location.href);
            url.searchParams.set("co_tenant_a_id", newId);
            window.history.pushState({}, "", url.toString());
          }
          await loadCoTenantData(
            "applyProfile",
            res.created_co_tenant_id || res.co_tenant_id
          );
        }
      } else {
        if (!haveValue(data?.is_edit)) {
          data.is_edit = true;
        }
        res = await axiosInstance.patch(
          `${process.env.REACT_APP_SERVER_URL}/users/profile/${originalUser?._id}`,
          data,
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        );
        const usertype = localStorage.getItem("usertype");
        await loadUser(usertype);
      }

      return res;
    } catch (err: any) {
      if (err?.response?.data?.errorKey === "account-already-present") {
        setGuarantorAccountPresent(true);
      } else {
        toast.error(
          err?.response?.data?.errormsg ||
          err?.response?.data?.error ||
          "Something went wrong"
        );
      }

      throw err;
    }
  };

  useEffect(() => {
    if (
      !isIframe ||
      flow !== "tenant" ||
      step !== OnboardingStep.Skor ||
      isCompletingIframeProfile.current ||
      sessionStorage.getItem("applicationProfileEditMode") === "true" ||
      new URLSearchParams(window.location.search).get("editProfile") === "true"
    ) {
      return;
    }

    isCompletingIframeProfile.current = true;
    const completeIframeProfile = async () => {
      try {
        await upsertUserProfile({
          is_edit: false,
          profile_completed: true,
          role: localStorage.getItem("usertype"),
        });
        const applicationProfileManagerToken = sessionStorage.getItem(
          "applicationProfileManagerToken"
        );
        if (
          localStorage.getItem("application_profile_child") === "true" &&
          applicationProfileManagerToken
        ) {
          localStorage.setItem("token", applicationProfileManagerToken);
          localStorage.removeItem("application_profile_child");
          sessionStorage.removeItem("applicationProfileManagerToken");
          window.location.replace("/application-profiles");
          return;
        }
        setIframeProfileCompleted(true);
        iframeCompletionEventTimer.current = setTimeout(() => {
          window.parent.postMessage(
            {
              type: "TENANT_ONBOARDING_COMPLETED",
              data: {
                id: originalUser?._id,
                profile_completed: true,
              },
            },
            "*"
          );
        }, 1000);
      } catch (err) {
        isCompletingIframeProfile.current = false;
        console.error("Error completing iframe onboarding:", err);
      }
    };

    void completeIframeProfile();
    return () => {
      if (iframeCompletionEventTimer.current) {
        clearTimeout(iframeCompletionEventTimer.current);
        iframeCompletionEventTimer.current = null;
      }
    };
  }, [flow, isIframe, step]);

  const requiresSubcategory = (status: string) => {
    return [
      constants.public_servant,
      constants.employed,
      constants.self_employed,
    ].includes(status);
  };

  const formHandler = {
    next: () =>
      setStep((prev) => {
        let newStep = getNextValidStep(prev, 1);
        if (isStepSkippedByConfig(newStep)) {
          newStep = getNextValidStep(newStep, 1);
        }
        setPrevStep(prev);
        if (newStep === OnboardingStep.MissingDocument)
          setMissingSkipAnalysis(false);
        if (isEditMode) {
          const params = new URLSearchParams(window.location.search);
          params.set("step", String(newStep));
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params.toString()}`
          );
        }
        return newStep;
      }),

    prev: () =>
      setStep((prev) => {
        let newStep = getNextValidStep(prev, -1);
        setPrevStep(prev);
        if (prev === OnboardingStep.MissingDocument)
          setMissingSkipAnalysis(true);
        if (isEditMode) {
          const params = new URLSearchParams(window.location.search);
          params.set("step", String(newStep));
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params.toString()}`
          );
        }
        return newStep;
      }),

    goTo: (targetStep: number) => {
      setPrevStep(step);
      if (
        step === OnboardingStep.MissingDocument &&
        targetStep === OnboardingStep.RequiredDocuments
      ) {
        setMissingSkipAnalysis(true);
      }
      if (isEditMode) {
        const params = new URLSearchParams(window.location.search);
        params.set("step", String(targetStep));
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${params.toString()}`
        );
      }
      setStep(targetStep);
    },
  };

  const sendMail = async (
    receiverEmail: string,
    emailType,
    guarantorRequestId: string
  ) => {
    const payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
      guarantorRequestId: undefined,
    };
    if (guarantorRequestId) {
      payload.guarantorRequestId = guarantorRequestId;
    }
    try {
      await sendUniversalMail(payload);
      await loadUser("tenant");
      toast.success(_t("emailSent"));
    } catch (err) {
      if (
        err?.response?.data?.success_res?.key === "guarantor-already-linked"
      ) {
        toast.error(_t("guarantorAlreadyLinked"));
      } else {
        toast.error(_t("errorSendingMail"));
      }
      throw err;
    }
  };

  const handleSendEmailToGuarantor = async (
    guarantorEmail,
    guarantorRequestId: string
  ) => {
    if (guarantorEmail === originalUser?.email) {
      toast.error(_t("youCannotAddYourselfAsGuarantor"));
      return;
    }
    try {
      await sendMail(guarantorEmail, "score", guarantorRequestId);
      navigate("/home");
    } catch {
      // sendMail already displays the relevant error and the form stays open.
    }
  };

  const handleSubmitFinalStep = async () => {
    try {
      let formData = {
        profile_completed: true,
        role: "tenant",
        is_edit: false,
        manual_kyc_doc_status: undefined,
      };
      if (modules?.includes("DISABLE_KYC")) {
        formData.manual_kyc_doc_status = "BYPASS";
      }
      await upsertUserProfile(formData);
      navigate(`/home`);
    } catch (err) {
      console.log("Error", err);
    }
  };

  // D accept (the decision screen already ran linkGurantor): resolve the
  // landlord the verified profile now reaches (case 13) or record that
  // nothing is shared yet (case 12), then show the G result. linkGurantor
  // alone links every app; landlords see the guarantee via the tenant's
  // shared applications.
  const handleBackingAccepted = async () => {
    const request = pendingGuaranteesRequests[0];
    const tenant = request?.tenant_id ?? {};
    const firstName = tenant.fname || (tenant.email ?? "").split("@")[0] || "";
    const fullName =
      `${tenant.fname ?? ""} ${tenant.lname ?? ""}`.trim() || firstName;
    console.log("[signup-flow]", "guarantor decision: accepted at end", {
      tenantId: tenant._id ?? null,
    });
    let landlordName: string | null = null;
    try {
      const apps = await getBackedTenantShared(tenant._id);
      for (const app of apps ?? []) {
        const names = getSharedLandlordNames(app);
        if (names.length > 0) {
          landlordName = names[0];
          break;
        }
      }
    } catch {
      console.log("[signup-flow]", "guarantor decision: sharing lookup failed");
    }
    const result = { fullName, firstName, landlordName };
    try {
      sessionStorage.setItem("signupGuarantorBacking", JSON.stringify(result));
    } catch { }
    console.log("[signup-flow]", "guarantor result shown", {
      fullName,
      landlordName,
    });
    setBackingResult(result);
  };

  // Cases 12-13: the G result only closes to the dashboard. Accept already ran
  // linkGurantor, so complete the profile here (otherwise the dashboard
  // bounces back to onboarding) and go home. Reject never reaches this
  // screen: it empties the request list and A mounts.
  const handleGuaranteeResultClose = async () => {
    console.log("[signup-flow]", "guarantor result: go to dashboard", {
      fullName: backingResult?.fullName ?? null,
      landlordName: backingResult?.landlordName ?? null,
    });
    setCompletingBacking(true);
    try {
      await upsertUserProfile({
        is_edit: false,
        profile_completed: true,
        role: localStorage.getItem("usertype"),
      });
    } catch {
      // upsertUserProfile already toasted; home still loads and the guard
      // returns an incomplete profile to onboarding (requests now empty, A shows).
    }
    try {
      sessionStorage.removeItem("signupGuarantorBacking");
    } catch { }
    setBackingResult(null);
    navigate("/home?welcome=true");
  };

  useEffect(() => {
    // D is the end-of-signup decision: the popup only shows at the Skor step,
    // never mid-onboarding.
    if (step === OnboardingStep.Skor && pendingGuaranteesRequests.length > 0) {
      console.log("[signup-flow]", "guarantor decision shown at end", {
        pendingCount: pendingGuaranteesRequests.length,
      });
    }
  }, [step, pendingGuaranteesRequests]);

  const loadPendingGuarantees = async (data?: any) => {
    setPendingRequestsGuranteesLoading(true);
    try {
      const response = await getPendingGuaantees(data);
      const firstGuarantee = haveValue(response?.success_res?.[0])
        ? [response?.success_res?.[0]]
        : [];
      setPendingGuaranteesRequests(firstGuarantee);
    } catch (e) {
      console.error(e);
      toast.error(
        _t(
          "failedToLoadPendingRequests",
          "Text used in guarantees pending requests popup"
        )
      );
    } finally {
      setPendingRequestsGuranteesLoading(false);
    }
  };

  const companyClientIdentificationWorkspace =
    clientIdentificationInvitationWorkspace ||
    (isClientIdentificationActive(user?.workspaceId) ? user.workspaceId : null);

  const finishCompanyOnboarding = () => {
    if (
      companyClientIdentificationWorkspace &&
      user?.consents?.client_identification_consent?.status !==
      constants.ACCEPTED
    ) {
      setShowCompanyClientIdentificationForm(true);
      return;
    }
    navigate("/home?welcome=true");
  };

  const renderCompanyCompletion = () => {
    if (
      showCompanyClientIdentificationForm &&
      companyClientIdentificationWorkspace
    ) {
      return (
        <TenantRequirementsFlow
          user={user}
          mode="auto"
          autoApplication
          workspace={companyClientIdentificationWorkspace}
          requireIdentification
          closable={false}
          onIdentificationSigned={async () => {
            await loadUser("tenant");
          }}
          onDone={() => {
            setShowCompanyClientIdentificationForm(false);
            navigate("/home?welcome=true");
          }}
        />
      );
    }

    return (
      <CompanyProfileCompletedModal
        companyName={user?.company_legal_name || formData?.company_legal_name}
        actionLabel={_t("goToMyDashboard")}
        onAction={finishCompanyOnboarding}
      />
    );
  };

  const renderStep = () => {
    switch (step) {
      case OnboardingStep.BasicInfo:
        return (
          <BasicInfoModal
            user={user}
            formData={formData}
            setFormData={setFormData}
            createUserProfile={upsertUserProfile}
            formHandler={formHandler}
            requiresSubcategory={requiresSubcategory}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            guarantorAccountPresent={guarantorAccountPresent}
            originalUser={originalUser}
            setGuarantorAccountPresent={setGuarantorAccountPresent}
            allowGuarantorEdit={allowGuarantorEdit || allowCoTenantEdit}
            isEditMode={isEditMode}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            selectedProtectedHousingDocs={selectedProtectedHousingDocs}
            setSelectedProtectedHousingDocs={setSelectedProtectedHousingDocs}
            isDummySignup={isDummySignup}
            setStep={setStep}
            guarantorRequestId={guarantor_a_id}
          />
        );
      case OnboardingStep.AuthenticateId:
        return (
          <AuthenticateYourId
            formHandler={formHandler}
            user={user}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            setRunDetectKycDocs={setRunDetectKycDocs}
            isEditMode={isEditMode}
            addedFiles={addedFiles}
            setAddedFiles={setAddedFiles}
            isKycSkippable={isKycSkippable}
            onSkipKyc={handleSkipKyc}
            onProgressChange={setIdentityStage}
          />
        );
      case OnboardingStep.RequiredDocuments:
        return (
          <RequiredDocumentsModal
            documentAnalysisResponse={documentAnalysisResponse}
            refreshDocumentAnalysis={refreshDocumentAnalysis}
            formHandler={formHandler}
            user={user}
            requiresSubcategory={requiresSubcategory}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            isFirstTime={isFirstTime}
            guarantor_a_id={guarantor_a_id}
            co_tenant_a_id={co_tenant_a_id}
            needWaitingJobForClave={true}
            isEditMode={isEditMode}
            cameFromMissing={prevStep === OnboardingStep.MissingDocument}
            modules={modules}
            handleSubmitFinalStep={handleSubmitFinalStep}
            isDummySignup={isDummySignup}
            setStep={setStep}
            isFormSubmitted={isFormSubmitted}
            setIsFormSubmitted={setIsFormSubmitted}
            deletedReviewFileIds={deletedReviewFileIds}
            setDeletedReviewFileIds={setDeletedReviewFileIds}
          />
        );
      case OnboardingStep.MissingDocument:
        return (
          <MissingDocument
            skipAnalysisOnBack={missingSkipAnalysis}
            documentAnalysisResponse={documentAnalysisResponse}
            docAnalysisLoading={documentAnalysisLoading}
            documentAnalysisStatus={documentAnalysisStatus}
            user={user}
            formHandler={formHandler}
            selectedOnboardingUsers={selectedOnboardingUsers}
            setSelectedOnboardingUsers={setSelectedOnboardingUsers}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            isEditMode={isEditMode}
            modules={modules}
            handleSubmitFinalStep={handleSubmitFinalStep}
            isDummySignup={isDummySignup}
            setStep={setStep}
            deletedReviewFileIds={deletedReviewFileIds}
            setDeletedReviewFileIds={setDeletedReviewFileIds}
          />
        );
      case OnboardingStep.DocumentScanning:
        return (
          <DocumentScanning
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            runDetectKycDocs={runDetectKycDocs}
            isEditMode={isEditMode}
            setAddedFiles={setAddedFiles}
            modules={modules}
            handleSubmitFinalStep={handleSubmitFinalStep}
            isDummySignup={isDummySignup}
            setStep={setStep}
          />
        );

      case OnboardingStep.Bank:
        if (
          isStepSkippedByConfig(OnboardingStep.Bank) ||
          !isStepAllowedForFlow(OnboardingStep.Bank)
        ) {
          return null;
        }
        return (
          <BankModal
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            loadGuarantorData={loadGuarantorData}
            loadCoTenantData={loadCoTenantData}
            guarantor_a_id={guarantor_a_id}
            co_tenant_a_id={co_tenant_a_id}
            originalUser={originalUser}
            isEditMode={isEditMode}
            modules={modules}
            handleSubmitFinalStep={handleSubmitFinalStep}
            isDummySignup={isDummySignup}
            setTinkModal={setTinkModal}
            isBankAdded={isBankAdded}
            setStep={setStep}
          />
        );

      case OnboardingStep.Guarantor:
        if (
          !isStepAllowedForFlow(OnboardingStep.Guarantor) ||
          isStepSkippedByConfig(OnboardingStep.Guarantor)
        ) {
          return null;
        }
        if (isRenew && !isGuarantor && !isEditMode) {
          return (
            <RenewGuarantorsStep
              user={user}
              onBack={formHandler.prev}
              onFinish={async () => {
                await handleCompleteOnboarding();
                navigate("/home?welcome=true");
              }}
            />
          );
        }
        return (
          <GuarantorModal
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            originalUser={originalUser}
            isEditMode={isEditMode}
            isDummySignup={isDummySignup}
            setStep={setStep}
          />
        );

      case OnboardingStep.FreeText:
        if (!isStepAllowedForFlow(OnboardingStep.FreeText)) {
          return null;
        }
        return null;

      case OnboardingStep.Skor:
        if (isIframe && flow === "tenant") {
          if (!iframeProfileCompleted) {
            return (
              <div id="main-app-loader">
                <Loader />
              </div>
            );
          }
          return <CompanyProfileCompletedModal iframeProfile />;
        }
        if (isCompanySelected && !isGuarantor && !isCoTenant && !isEditMode) {
          return renderCompanyCompletion();
        }
        if (
          !isStepAllowedForFlow(OnboardingStep.Skor) ||
          isStepSkippedByConfig(OnboardingStep.Skor)
        ) {
          return null;
        }
        // Cases 12-13: D instead of A. With pending guarantee requests the
        // decision popup (page bottom, fixed overlay) covers this step, so the
        // create-application screen stays unmounted. Accept leads to the G
        // result modal and then home; decline empties the list and A mounts.
        return (
          <>
            {pendingGuaranteesRequests.length > 0
              ? null
              : !createdApp && (
                <CreateApplicationStep
                  onBack={formHandler.prev}
                  updateTenantData={upsertUserProfile}
                  onCreated={setCreatedApp}
                />
              )}
            <PostApplicationModals
              createdApp={createdApp}
              user={user}
              requiredClientIdentificationWorkspace={
                clientIdentificationInvitationWorkspace
              }
              pendingStage={pendingStage}
              setPendingStage={setPendingStage}
              onClose={() => setCreatedApp(null)}
              refreshUser={() => loadUser("tenant")}
            />
          </>
        );

      case OnboardingStep.CompanyCompleted:
        return renderCompanyCompletion();

      default:
        return (
          <BasicInfoModal
            user={user}
            formData={formData}
            setFormData={setFormData}
            createUserProfile={upsertUserProfile}
            formHandler={formHandler}
            requiresSubcategory={requiresSubcategory}
            isGuarantor={isGuarantor}
            isCoTenant={isCoTenant}
            guarantorAccountPresent={guarantorAccountPresent}
            originalUser={originalUser}
            setGuarantorAccountPresent={setGuarantorAccountPresent}
            isEditMode={isEditMode}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            selectedProtectedHousingDocs={selectedProtectedHousingDocs}
            setSelectedProtectedHousingDocs={setSelectedProtectedHousingDocs}
          />
        );
    }
  };

  const [companyLogo, setCompanyLogo] = useState<string | null>(null);
  const { getWorkspaceDetailsFromSlug, getWorkspaceDetails } = useContext(
    LandLordContext
  ) as any;

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const wid = q.get("wid");
    const slug = window.location.pathname.split("/").pop();
    if (user?.company_logo || user?.invitationLogo) {
      setCompanyLogo(user.company_logo || user.invitationLogo);
    }
    const applyWorkspaceData = (data: any) => {
      if (!data) return;
      if (data?.invitationLogo)
        setCompanyLogo((prev: any) => prev ?? data.invitationLogo);
      if (data?.company_logo)
        setCompanyLogo((prev: any) => prev ?? data.company_logo);
      if (Array.isArray(data?.skip_steps))
        setWorkspaceSkipSteps(data.skip_steps);
      if (isClientIdentificationActive(data)) {
        setClientIdentificationInvitationWorkspace(data);
      }
    };
    // 1) requestProfileLink invite: ProtectedRoute strips query and stores "landlordId_workspaceId" in cookie
    const rawLink =
      (cookies as any)?.requestProfileLink || q.get("requestProfileLink");
    if (rawLink) {
      getWorkspaceDetails?.(rawLink)
        ?.then((res: any) => {
          applyWorkspaceData(res?.data?.data ?? res?.data);
        })
        .catch(() => { });
      return;
    }
    // 2) wid/slug flow (custom link)
    if (wid || (slug && slug !== "onboarding" && slug !== "edit")) {
      getWorkspaceDetailsFromSlug?.(slug, wid)
        ?.then((res: any) => {
          applyWorkspaceData(res?.data?.data ?? res?.data);
        })
        .catch(() => { });
    }
  }, [
    user?.company_logo,
    user?.invitationLogo,
    (cookies as any)?.requestProfileLink,
  ]);

  const showProgress =
    !isEditMode && ((!isGuarantor && !isCoTenant) || showSidebar);
  const showGuarantorProgress = isGuarantor && !isEditMode && showSidebar;
  const showCoTenantProgress = isCoTenant && !isEditMode && showSidebar;
  const showApplicationProfileProgress =
    isIframe &&
    localStorage.getItem("application_profile_child") === "true" &&
    !isEditMode;
  const skipFinancialStudy = effectiveSkipSteps.includes(
    constants.SKIP_STEPS_ENUM.bank_onboarding
  );
  const isCompanyFlow =
    isCompanySelected && !isGuarantor && !isCoTenant && !isEditMode;

  return (
    <div
      className={`onboarding-main${showProgress ? " tenant-onboarding-shell" : ""
        }`}
    >
      {showRenewExit && (
        <div className="renew-exit-topbar" aria-label="renew top bar">
          <LanguageSwitcher
            currentLang={currentLang}
            isLangChanging={isLangChanging}
            onChange={(lang) => handleLanguageChange(lang)}
          />
          <button
            type="button"
            className="renew-exit-btn"
            onClick={() => setShowExitModal(true)}
            aria-label="Exit renewal"
            style={{
              background: "#fff",
              border: "1px solid #e5eae7",
              borderRadius: 999,
              padding: "8px 18px",
              height: 36,
              fontSize: 14,
              fontWeight: 600,
              color: "#1a2e2c",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              lineHeight: 1,
            }}
          >
            {_t("exit", "Exit")}
          </button>
        </div>
      )}
      {showRenewExit && (
        <RenewExitConfirm
          open={showExitModal}
          onClose={() => setShowExitModal(false)}
          onConfirm={handleExitOnboarding}
        />
      )}
      {/* Single fixed switcher for the regular tenant flow. Hidden during
          renewal because the renew-exit-topbar above already renders one —
          rendering both caused the overlapping pills. */}
      {!isGuarantor && !isEditMode && !showRenewExit && (
        <div
          className="tenant-onboarding-language-switch"
          aria-label="language switch"
        >
          <LanguageSwitcher
            currentLang={currentLang}
            isLangChanging={isLangChanging}
            onChange={(lang) => handleLanguageChange(lang)}
          />
        </div>
      )}
      {/* Mobile top nav language switcher – mobile-only fallback for flows
          without a progress rail (see onboardingProgress.css). Excluded when
          the renew topbar is shown (it owns the switcher there) and in edit
          mode (EditBasicInfo has its own language dropdown – showing both
          would be two changers at once). */}
      {((!isGuarantor && !isCoTenant) || showSidebar) &&
        !showRenewExit &&
        !isEditMode && (
          <div
            className="onboarding-mobile-topbar"
            aria-label="language switch"
          >
            <LanguageSwitcher
              currentLang={currentLang}
              isLangChanging={isLangChanging}
              onChange={(lang) => handleLanguageChange(lang)}
            />
          </div>
        )}
      {showProgress &&
        !showGuarantorProgress &&
        !showCoTenantProgress &&
        !showApplicationProfileProgress && (
          <OnboardingProgress
            step={step}
            identityStage={identityStage}
            skipFinancialStudy={skipFinancialStudy}
            companyLogo={companyLogo}
            identityStillValid={isKycAutoSkippable}
            isCompany={isCompanyFlow}
            isIframe={isIframe}
            hideLanguageSwitcher={showRenewExit}
          />
        )}
      {showApplicationProfileProgress && (
        <CoTenantOnboardingProgress
          step={step}
          coTenantName={
            (user?.fname ? `${user.fname} ${user.lname || ""}`.trim() : "") ||
            user?.email
          }
          originalUser={originalUser}
          applicationProfiles={(() => {
            try {
              const raw = sessionStorage.getItem("applicationProfiles");
              return raw ? JSON.parse(raw) : undefined;
            } catch {
              return undefined;
            }
          })()}
          activeApplicationProfileEmail={sessionStorage.getItem(
            "activeApplicationProfileEmail"
          )}
        />
      )}
      {showGuarantorProgress && (
        <GuarantorOnboardingProgress
          step={step}
          guarantorName={
            guarantorName ||
            (user?.fname ? `${user.fname} ${user.lname || ""}`.trim() : "")
          }
          originalUser={originalUser}
          guarantors={(() => {
            try {
              const raw = sessionStorage.getItem("selfManagedGuarantors");
              return raw ? JSON.parse(raw) : undefined;
            } catch {
              return undefined;
            }
          })()}
        />
      )}
      {showCoTenantProgress && (
        <CoTenantOnboardingProgress
          step={step}
          coTenantName={
            coTenantName ||
            (user?.fname ? `${user.fname} ${user.lname || ""}`.trim() : "")
          }
          originalUser={originalUser}
          coTenants={(() => {
            try {
              const raw = sessionStorage.getItem("selfManagedCoTenants");
              return raw ? JSON.parse(raw) : undefined;
            } catch {
              return undefined;
            }
          })()}
        />
      )}
      {pageLoading ? (
        <div id="main-app-loader">
          <Loader />
        </div>
      ) : (
        renderStep()
      )}
      {showGuarantorModel && (
        <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen">
          <div className="popup-content2 popup-content bg-white guarantorDocuments">
            <div className="row">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-between heading-section">
                <div>
                  <h4>{_t("wouldYouLikeToProvideGuarantorDocuments")}</h4>
                </div>
                <div className="canceiconwrapper">
                  <img
                    src={Cancelimg}
                    alt="icon"
                    className="canceicon"
                    onClick={() => navigate("/home")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <p className="tenant-doc-text">
                    {_t(
                      "continueUploadingGuarantorInfoDocumentsOnBehalfOPfTheGuarantorOrYouCanRequestYourGuarantorToProvideTheirInfoAndDocumentsOnTheirOwn"
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center custom-gap-3 buttonWrapperDocument custom-mt-4 custom-mb-2">
              <button
                type="button"
                className="btnNext btnnextpre w-100"
                onClick={() => setlessGuarantorInfoModal(true)}
              >
                {_t("sendRequestToProvideDocuments")}
              </button>
              <button
                type="button"
                className="btnNext w-100"
                onClick={() => setShowGuarantorModel(false)}
              >
                {_t("provideGuarantorDocments")}
              </button>
            </div>
          </div>
        </div>
      )}
      {lessGuarantorInfoModal && (
        <FlatmateOrGuarantorAddForm
          isOpen={lessGuarantorInfoModal}
          onClose={() => {
            setlessGuarantorInfoModal(false);
            if (useCompactGuarantorForm) {
              navigate("/home");
            }
          }}
          setModal={(isOpen) => {
            setlessGuarantorInfoModal(isOpen);
            if (!isOpen && useCompactGuarantorForm) {
              navigate("/home");
            }
          }}
          isGuarantor={isGuarantor}
          handleSendEmailToGuarantor={handleSendEmailToGuarantor}
          selectedUser={
            useCompactGuarantorForm
              ? {
                ...user,
                gurantor_relation: formData?.gurantor_relation,
              }
              : undefined
          }
          editGuarantorRequestId={
            useCompactGuarantorForm ? guarantor_a_id : undefined
          }
        />
      )}
      {/* D lives at the end of signup: only the Skor step shows the decision
          screen, never mid-onboarding. */}
      <GuarantorDecisionScreen
        show={
          pendingGuaranteesRequests.length > 0 && step === OnboardingStep.Skor
        }
        request={pendingGuaranteesRequests[0]}
        loadPendingGuarantees={loadPendingGuarantees}
        loading={pendingRequestsGuranteesLoading}
        onAccept={handleBackingAccepted}
        setAcceptedGuaranteeName={setAcceptedGuaranteeName}
        _t={_t}
      />

      <RequestAcceptingModal
        show={isAcceptModalOpen}
        onClose={() => setIsAcceptModalOpen(false)}
        acceptedGuaranteeName={acceptedGuaranteeName}
      />
      {onfidoModal && (
        <OnfidoModal
          onClose={() => {
            setOnfidoModal(false);
            setStep(4);
          }}
          onUploadComplete={() => {
            setOnfidoModal(false);
            setStep(5);
          }}
        />
      )}
      {tinkModal && (
        <TinkModal
          onSuccess={() => { }}
          onClose={() => {
            setTinkModal(false);
            setIsBankAdded(true);
          }}
        />
      )}
      {backingResult && (
        <GuarantorBackingScreen
          show
          fullName={backingResult.fullName}
          firstName={backingResult.firstName}
          landlordName={backingResult.landlordName}
          onDashboard={handleGuaranteeResultClose}
          dashboardBusy={completingBacking}
          _t={_t}
        />
      )}
    </div>
  );
}

export default OnboardingMain;
